<template>
  <div class="mt-6 w-full flex flex-wrap sm:flex-nowrap gap-6">
    <div class="w-full h-96 border border-secondary-300/40 rounded-xl">
      <div class="border-b border-secondary-300/40">
        <div class="ml-4 my-4 h-4 w-48 bg-neutral-600/40 rounded-xl"></div>
      </div>
    </div>
    <div class="w-full h-96 border border-secondary-300/40 rounded-xl">
      <div class="border-b border-secondary-300/40">
        <div class="ml-4 my-4 h-4 w-48 bg-neutral-600/40 rounded-xl"></div>
      </div>
    </div>
  </div>
  <div class="mt-6 w-full h-96 border border-secondary-300/40 rounded-xl">
    <div class="border-b border-secondary-300/40">
      <div class="ml-4 my-4 h-4 w-48 bg-neutral-600/40 rounded-xl"></div>
    </div>
  </div>
</template>
